var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{ref:'home_'+_vm.selectedRouteName,attrs:{"name":_vm.selectedRouteName}}),_c('div',{ref:"externalPluginWrapperRef",staticStyle:{"display":"none"},attrs:{"id":"external-plugins-wrapper"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }